import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshRightLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Refresh right",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.9236 16.0242C15.6474 17.8738 13.5069 19.0854 11.0837 19.0854C7.17435 19.0854 4 15.9192 4 12.0017C4 8.09232 7.17435 4.91797 11.0837 4.91797C14.9366 4.91797 18.0705 7.98732 18.1755 11.8159",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.0001 8.09766L18.3919 11.9012L14.6094 10.3019",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRefreshRightLine;
